import React from "react";
import "./App.css";
import "./HeaderMobile.css";
import "./HeaderCompact.css";
import "./LightTheme.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Nominations from "./pages/Nominations";
import AboutUs from "./pages/AboutUs";
import Ceremony from "./pages/Ceremony";
import HallOfFame from "./pages/HallOfFame";
import CompanyDetail from "./pages/CompanyDetail";
import Enter from "./pages/Enter";
import Support from "./pages/Support";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import Admin from "./pages/Admin";

function AppLayout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdmin && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nominations" element={<Nominations />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/ceremony" element={<Ceremony />} />
        <Route path="/hall-of-fame" element={<HallOfFame />} />
        <Route path="/company/:slug" element={<CompanyDetail />} />
        <Route path="/enter" element={<Enter />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/admin/*" element={<Admin />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </div>
  );
}

export default App;
